import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import { env_user } from '../conf/environ_user';

type RecaptchaProviderProps = {
    children: React.ReactNode;
};

export const RecaptchaProvider: React.FC<RecaptchaProviderProps> = ({ children }) => {
    return (
        <GoogleReCaptchaProvider reCaptchaKey={env_user.recaptcha_site_key} language='japanese'>
            {children}
        </GoogleReCaptchaProvider>
    );
};
